/* eslint-disable import/max-dependencies */
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import type {
  Group,
  List,
} from "@fas/cpa-cabinet-ui/lib/SmartlinkGenerator/SmartlinkGenerator.types";
import { useLinkGenerator } from "@fas/cpa-state-manager/redux/hooks/useLinkGenerator";
import {
  setGeneratedLinks,
  setSelectedValues,
} from "@fas/cpa-state-manager/redux/actions/linkGenerator/actions";
import { addNotification } from "@fas/cpa-state-manager/redux/actions/notifications";
import {
  useHandleRequest,
  useIsAffiliate,
} from "@fas/cpa-state-manager/redux/hooks";
import { getGeneratedLinks } from "@fas/cpa-state-manager/services/selectors";
import {
  generateSmartOffer,
  smartOfferCheck,
} from "../../services/deprecatedApi";

export type UseSmartlinkGeneratorHook = {
  title?: string;
  groups: Array<Group>;
  optionsList: List;
  values: Record<string, string>;
  handleChange: (arg0: string, arg1: string) => any;
  handleGenerateClick: () => void;
  handleClearClick: () => void;
  disabled: boolean;
  generateButtonProps: {
    variant: "gradient";
    disabled: boolean;
  };
  clearButtonProps: {
    variant: "transparent";
  };
};

export const useSmartlinkGenerator = (): UseSmartlinkGeneratorHook => {
  const { isLoading, changeLoading, onFail, onFinally } =
    useHandleRequest("smartlinkGenerator");
  const isAffiliate = useIsAffiliate();
  const linkGeneratorProps = useLinkGenerator();
  const dispatch = useDispatch();
  const [isAwailableGenerateSmartlink, setIsAwailableGenerateSmartlink] =
    useState(false);
  const list = useSelector((state) => getGeneratedLinks(state));

  function runCheckSmartOffer() {
    changeLoading(true);
    smartOfferCheck(linkGeneratorProps.selectedValues)
      .then((v) => setIsAwailableGenerateSmartlink(v))
      .catch(onFail)
      .finally(onFinally);
  }

  useEffect(() => {
    runCheckSmartOffer();
  }, [linkGeneratorProps.selectedValues]);

  const handleClearClick = () => {
    dispatch(
      setSelectedValues({
        isTraffic: "0",
        isStraight: "1",
        isMainstream: "0",
        isPreLander: "1",
        isPPL: "1",
      })
    );
  };

  const handleGenerateClick: () => void = () => {
    changeLoading(true);
    generateSmartOffer(linkGeneratorProps.selectedValues)
      .then((offer) => {
        dispatch(setGeneratedLinks([offer, ...list]));
        dispatch(
          addNotification({
            severity: "success",
            message: "Link was successfully generated",
          })
        );
        setIsAwailableGenerateSmartlink(false);
      })
      .catch(onFail)
      .finally(onFinally);
  };

  return {
    groups: linkGeneratorProps.groups,
    optionsList: linkGeneratorProps.optionsList,
    values: linkGeneratorProps.selectedValues,
    handleChange: linkGeneratorProps.onChangeLinkOption,
    disabled: isLoading || !isAffiliate,
    generateButtonProps: {
      variant: "gradient",
      disabled: isLoading || !isAffiliate || !isAwailableGenerateSmartlink,
    },
    clearButtonProps: {
      variant: "transparent",
    },
    handleClearClick,
    handleGenerateClick,
  };
};
